// Maps a GST "constitution of business" value (lowercased/trimmed) to the matching
// ATOM Client Category / Sub-Category names. Shared by Add Client and Add Lead's
// GSTIN-verify auto-fill.
export const ctbToCategoryMap: Record<string, { category: string; subCategory?: string }> = {
  proprietorship: { category: "Individual" },
  partnership: { category: "Partnership Firm" },
  "hindu undivided family": { category: "Hindu Undivided Family" },
  "private limited company": { category: "Company", subCategory: "Private Limited" },
  "public limited company": { category: "Company", subCategory: "Public Limited" },
  "society/club/trust": { category: "Trust", subCategory: "Public Trust" },
  "association of persons": { category: "Association of Persons" },
  "government department": { category: "Government", subCategory: "Central" },
  "public sector undertaking": { category: "Company", subCategory: "Government" },
  "unlimited company": { category: "Company", subCategory: "Private Limited" },
  "limited liability partnership": { category: "Limited Liability Partnership" },
  "local authority": { category: "Local Authority" },
  "statutory body": { category: "Artificial Juridical Person" },
  "foreign limited liability partnership": { category: "Limited Liability Partnership" },
  "foreign company registered (in india)": { category: "Company", subCategory: "Foreign" },
  "one person company": { category: "Company", subCategory: "OPC" },
  "section 8 company": { category: "Company", subCategory: "Section-8" },
  "others (please specify)": { category: "Artificial Juridical Person" },
  others: { category: "Artificial Juridical Person" },
};

// Builds a single-line address string from a GST "pradr.addr" response object.
// Shared by Add Client and Add/Edit Lead's GSTIN-verify auto-fill.
// The GST details Add Client stores when a GSTIN is verified - kept on the lead at
// verification and copied onto the client when the lead is converted
export const buildGstDetails = (gst: any) => {
  const addr = gst?.pradr?.addr || {};
  return {
    legalName: gst?.lgnm || "",
    tradeName: gst?.tradeNam || "",
    constitutionOfBusiness: gst?.ctb || "",
    registrationType: gst?.dty || "",
    gstRegistrationDate: gst?.rgdt || "",
    placeOfSupply: addr.stcd || "",
    buildingName: addr.bnm || "",
    street: addr.st || "",
    city: addr.dst || "",
    state: addr.stcd || "",
    pincode: addr.pncd || "",
  };
};

export const getAddressFromGst = (address: any) => {
  let result = "";
  if (address?.bno) {
    result += `${address?.bno}, `;
  }
  if (address?.flno) {
    result += `${address?.flno}, `;
  }
  if (address?.bnm) {
    result += `${address.bnm}, `;
  }
  if (address?.st) {
    result += `${address.st}, `;
  }
  if (address?.locality) {
    result += `${address.locality}, `;
  }
  if (address?.loc) {
    result += `${address.loc}, `;
  }
  if (address?.dst) {
    result += `${address.dst}, `;
  }
  if (address?.stcd) {
    result += `${address.stcd} - `;
  }
  if (address?.pncd) {
    result += address.pncd;
  }
  return result;
};
